import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    IterableDiffers, DoCheck, IterableDiffer,
} from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { safeClone } from '@client/app/shared/utils/object-utils';

export interface TabOption {
    name: string;
    value: any;
    faIcon?: string;
    tooltip?: string;
}

@Component({
    selector: 'mon-tabs',
    templateUrl: './mon-tabs.component.html',
    standalone: false,
})
export class MonTabsComponent implements OnInit, DoCheck {
    @Input() status: any;
    @Input() options: TabOption[] = [];
    @Input() search: string | null = '';
    @Input() maxOptionsDisplay: number = 4;
    @Input() minSearchLength: number = 3;
    @Input() showSearch: boolean = false;
    @Input() showFiltersBtn: boolean = false;
    @Input() isFiltersOpen: boolean = false;
    @Output() isFiltersOpenChange = new EventEmitter<boolean>();

    @Output() onStatus = new EventEmitter<any>();
    @Output() onSearch = new EventEmitter<string>();
    @Output() statusChange = new EventEmitter<any>();

    moreOptions: TabOption[] = [];
    moreActive: boolean = false;
    optionsDiffer: IterableDiffer<TabOption>;

    constructor (
        private translateService: TranslateService,
        private iterableDiffers: IterableDiffers,
    ) {
        this.optionsDiffer = this.iterableDiffers.find(this.options).create();
    }

    ngOnInit () {
        this.options = this.options || [];
        this.minSearchLength = parseInt(this.minSearchLength.toString()) || 3;
        this.search = this.search || '';
        this.moreOptions = [];
        this.moreActive = false;
        this.maxOptionsDisplay = parseInt((this.maxOptionsDisplay || 0).toString()) || 4;
        this.showSearch = this.showSearch || false;

        this.updateOptionsDisplay();
    }

    ngDoCheck () {
        const diffRes = this.optionsDiffer.diff(this.options);
        if (diffRes) {
            this.updateOptionsDisplay();
        }
    }

    private updateOptionsDisplay () {
        if (this.options && this.options.length > this.maxOptionsDisplay) {
            const allOptions = safeClone(this.options);
            this.moreOptions = allOptions.slice(this.maxOptionsDisplay);
            this.options = allOptions.slice(0, this.maxOptionsDisplay);
        }
    }

    callback (tab: any) {
        if (this.status !== tab) {
            this.status = tab;
            this.moreActive = false;

            this.moreOptions.forEach((option) => {
                if (option.value === this.status) {
                    this.moreActive = true;
                    return;
                }
            });
        }
        this.onStatus.emit(tab);
        this.statusChange.emit(tab);
    }

    changeSearch (search: string) {
        this.search = search;
        this.onSearch.emit(this.search);
    }

    toggleShowFilters () {
        this.isFiltersOpen = !this.isFiltersOpen;
    }

    tabsCount (): number {
        return Object.keys(this.options).length;
    }

    getFiltersTranslation (): string {
        if (Boolean(this.isFiltersOpen)) {
            return this.translateService.getString('Close filters');
        } else {
            return this.translateService.getString('Open filters');
        }
    }

    trackByKey (index: number): any {
        return index;
    }
}
